import { render, staticRenderFns } from "./MdcPlug.vue?vue&type=template&id=26cac7a9"
import script from "./MdcPlug.vue?vue&type=script&lang=js"
export * from "./MdcPlug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports